import * as React from "react";

export const Container = ({ children }) => {
  return (
    <div className="account-settings-container">
      <div className="settings-inner">{children}</div>
    </div>
  );
};
export const Menu = ({ children }) => {
  return <div className="settings-menu">{children}</div>;
};
export const Page = ({ children }) => {
  return <div className="settings-page">{children}</div>;
};
